import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { InfoModalComponent } from '@components/info-modal/info-modal.component';
import { ModalData } from '@modules/modal/interfaces';

@Injectable({ providedIn: 'root' })
export class ModalService {
  constructor(private readonly dialog: MatDialog) {}

  private open<T, D = any, R = any>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<D>,
  ): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, config);
  }

  private currentInfoRef: MatDialogRef<InfoModalComponent, boolean> | null = null;

  infoModal(
    data: ModalData,
    bgClose: boolean = false,
    id: string = 'confirm-rule-modal',
  ): MatDialogRef<InfoModalComponent, boolean> {
    if (this.currentInfoRef) {
      const ref: any = this.currentInfoRef;
      let state: string | null = null;

      if (typeof ref.getState === 'function') {
        state = ref.getState();
      } else if (ref._containerInstance?.['_state']?.value) {
        state = ref._containerInstance._state.value;
      }

      if (state === 'OPEN') {
        return this.currentInfoRef;
      }

      this.currentInfoRef = null;
    }

    const ref = this.open(InfoModalComponent, {
      id,
      data,
      panelClass: 'lsap-info-dialog',
      disableClose: bgClose,
      autoFocus: true,
      restoreFocus: true,
      hasBackdrop: true,
      closeOnNavigation: false,
    });

    this.currentInfoRef = ref;

    ref.afterClosed().subscribe(() => {
      this.currentInfoRef = null;
    });

    return ref;
  }
}
